// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"58316277","208":"04fc4075","315":"e89bd4b1","409":"44cdfaea","419":"f7a54232","439":"6d602701","631":"19b35c5a","771":"5b1046d0","774":"df2ffcb8","787":"cf4636a5"}[chunkId] + ".chunk.js";
};